import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import ChatIcon from "../icons/ChatIcon";
import Logo from "../toolkit/Logo";
import { getIncognitoEmail,getisEmp } from "../utils/Token";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

export default function SmallScreen({
  icons,
  userSettings,
  handleOpenNavMenu,
  handleCloseNavMenu,
  handleOpenUserMenu,
  handleCloseUserMenu,
  anchorElUser,
  anchorElNav,
  handleSubMenuClick,
  switchToIncognitoUser,
  HasNotificationcount
}) {
  const incognitoEmail = getIncognitoEmail() ?? "";
  return (
    <Toolbar disableGutters sx={{ display: "flex" }}>
      <Box sx={{ flexGrow: 1, display: "flex" }}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{
            display: { xs: "block", md: "none" },
          }}
        >
          {/* {icons.map((Icon, i) => (
            <MenuItem key={i} onClick={handleSubMenuClick.bind(null, i)}>
              <Icon />
            </MenuItem>
          ))} */}
          <Button
            sx={{
              display: "block",
              paddingLeft: 0,
              paddingRight: 0,
              minWidth: "2.5rem",
            }}
            hidden={getisEmp() === "true"}
            onClick={handleSubMenuClick}
          >
            <ChatIcon width="1.25rem" hasNotification={HasNotificationcount} />
          </Button>
        </Menu>
      </Box>
      <Logo variant="h6" />

      <Box sx={{ flexGrow: 0 }}>
        <Tooltip title="Open settings">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar alt="Avatar" src="/static/images/avatar/2.jpg" />
          </IconButton>
        </Tooltip>
        
         <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >

          {incognitoEmail !== "" && 
            <MenuItem onClick={switchToIncognitoUser}>
                <Typography textAlign="center">Switch to - {incognitoEmail}</Typography>
            </MenuItem>
          }

          <MenuItem
              style={{
                color: "#667085",
                cursor: "pointer",
                marginBottom: "10px",
                textDecoration: "none",
              }}
              href="/MyAccount">
                <PersonOutlineOutlinedIcon />My Account
          </MenuItem>
          {userSettings.map((setting) => (
            <MenuItem key={setting.id} onClick={setting.onClick || handleCloseUserMenu}>
              <Typography textAlign="center"> <LogoutIcon /> {setting.text}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Toolbar>
  );
}
